import clsx from 'clsx';
import { node, string } from 'prop-types';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { SwitchButtons, useHomePageContext } from 'components';
import { PAGE_TYPES } from 'constants';
import { routes } from 'router';

import 'assets/styles/components/form/search-bar.scss';

const SearchBar = ({ children, className = '' }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const tabs = useMemo(() => {
    let baseTabs = [
      {
        name: PAGE_TYPES.travels,
        labelKey: 'buttons.trips',
        icon: { name: 'umbrella-beach', style: 'fad' },
        disabled: false
      },
      {
        name: PAGE_TYPES.leisures,
        labelKey: 'buttons.leisures',
        icon: { name: 'ferris-wheel', style: 'fad' },
        disabled: false,
        dataTestId: 'leisuresTabButton'
      },
      {
        name: PAGE_TYPES.sport,
        labelKey: 'buttons.sport',
        icon: { name: 'dumbbell', style: 'fad' },
        disabled: false,
        dataTestId: 'sportTabButton'
      },
      {
        name: PAGE_TYPES.giftcards,
        labelKey: 'buttons.giftcards',
        icon: { name: 'gift', style: 'fad' },
        disabled: false,
        tagElement: <span className="tag-new">{t('new')}</span>
      }
    ];

    return baseTabs;
  }, []);

  const { pageType } = useHomePageContext();

  const handleClick = (pageName) => {
    let path = '';
    switch (pageName) {
      case PAGE_TYPES.travels:
        path = routes.travelHomePage.path;
        break;
      case PAGE_TYPES.leisures:
        path = routes.leisureHomePage.path;
        break;
      case PAGE_TYPES.sport:
        path = routes.sportHomePage.path;
        break;
      case PAGE_TYPES.giftcards:
        path = routes.giftcardHomePage.path;
        break;
      default:
        break;
    }

    navigate(path);
  };

  return (
    <div className={clsx('search-bar-container', className)}>
      <SwitchButtons buttons={tabs} activeButton={pageType} onSelect={(data) => handleClick(data.name)} />
      {children}
    </div>
  );
};

SearchBar.propTypes = {
  children: node.isRequired,
  className: string
};

export default SearchBar;
